import { lazyLoad } from 'utils/loadable';

export const RecipePage = lazyLoad(
  () => import('./index'),
  module => module.RecipePage,
);
